
import type {
  HTMLAttributes,
} from 'react'

import {
  Card,
  CardContent,
  CardHeader,
} from './card'

import {
  Skeleton,
  SkeletonGroup,
  SkeletonText,
} from './skeleton'

import { cn } from '@/shared/lib/cn'

export interface SkeletonCardProps
  extends HTMLAttributes<HTMLDivElement> {
  showAvatar?: boolean
  contentLines?: number
  showFooter?: boolean
  loadingLabel?: string
}

export function SkeletonCard({
  showAvatar = false,
  contentLines = 3,
  showFooter = false,
  loadingLabel = 'Loading card',
  className,
  ...props
}: SkeletonCardProps) {
  return (
    <SkeletonGroup
      {...props}
      label={loadingLabel}
      className={className}
    >
      <Card>
        <CardHeader>
          <div className="flex w-full items-center gap-4">
            {showAvatar ? (
              <Skeleton
                shape="circle"
                className="h-11 w-11 shrink-0"
              />
            ) : null}

            <div className="min-w-0 flex-1 space-y-2">
              <Skeleton
                shape="text"
                className="h-4 w-40"
              />

              <Skeleton
                shape="text"
                className="h-3 w-64 max-w-full"
              />
            </div>
          </div>
        </CardHeader>

        <CardContent>
          <SkeletonText
            lines={contentLines}
          />

          <div className="mt-6 grid grid-cols-2 gap-4">
            <Skeleton
              className="h-16"
            />

            <Skeleton
              className="h-16"
            />
          </div>

          {showFooter ? (
            <div
              className={cn(
                'mt-6 flex',
                'justify-end gap-3',
              )}
            >
              <Skeleton className="h-10 w-24" />
              <Skeleton className="h-10 w-28" />
            </div>
          ) : null}
        </CardContent>
      </Card>
    </SkeletonGroup>
  )
}